import React, { useState } from "react";
import { Assort } from "../../../../models/Assort";
import EAQuantitySelector from "../../../shared/QuantitySelector/EAQuantitySelector";

interface IProps {
  item: Assort;
  onAddLine: (assort: Assort, qnt: number) => void;
}

const AssortLineQntButtons: React.FC<IProps> = ({ item, onAddLine }) => {
  const [qnt, setQnt] = useState<number>(0);

  const handleIncrement = () => {
    onAddLine(item, 1);
    setQnt(qnt + 1);
  };

  const handleDecrement = () => {
    onAddLine(item, -1);
    setQnt(qnt - 1);
  };

  const handleChange = (newValue: number) => {
    const diff = newValue - qnt;
    onAddLine(item, diff);
    setQnt(newValue);
  };

  return (
    <EAQuantitySelector
      value={qnt}
      onChange={handleChange}
      onIncrement={handleIncrement}
      onDecrement={handleDecrement}
      min={0}
      max={99}
    />
  );
};

export default AssortLineQntButtons;
